<rt-icon-button
  (click)="editDropdown.open = !editDropdown.open"
  [variant]="type === 'list' ? 'outline' : 'plain'"
  [pressed]="editDropdown.open"
  rt-overlay-origin
  #editDropdownTrigger="rtOverlayOrigin"
  iconName="more-horiz"
  shape="square"
/>
<ng-template
  (backdropClick)="editDropdown.open = false"
  [origin]="editDropdownTrigger"
  #editDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown [width]="DropdownWidth.SmallX">
    @if (offer.kind === OfferKind.Job) {
      @if (offer.status === OfferStatus.Draft || offer.status === OfferStatus.Archived) {
        <rt-dropdown-item [routerLink]="['/offers', offer.slug, 'notes']">
          <rt-icon prefix name="pipeline-notes" />
          {{ 'app.offer_form_actions.go_to_notes' | translate }}
        </rt-dropdown-item>
        <rt-dropdown-item [routerLink]="['/offers', offer.slug, 'attachments']">
          <rt-icon prefix name="folder" />
          {{ 'app.offer_form_actions.go_to_files' | translate }}
        </rt-dropdown-item>
      }
    }

    @if (
      offer.kind !== OfferKind.TalentPool &&
      (offer.status === OfferStatus.Internal || offer.status === OfferStatus.Published)
    ) {
      <rt-dropdown-item [href]="offer.url!" hrefTarget="_blank" (click)="trackPreview.emit()">
        <rt-icon prefix name="open-in-new" />
        {{ 'app.offers.view' | translate }}
      </rt-dropdown-item>
    }
    @if (canManageJobs) {
      <rt-dropdown-item (click)="action.emit(ActionType.Duplicate)">
        <rt-icon prefix name="content-copy" />
        {{ 'app.offers.duplicate' | translate }}
      </rt-dropdown-item>
      @if (offer.status !== OfferStatus.Archived) {
        <rt-dropdown-item (click)="action.emit(ActionType.Archive)">
          <rt-icon prefix name="archive" />
          {{ 'app.offers.archive' | translate }}
        </rt-dropdown-item>
      }
      @if (offer.status === OfferStatus.Archived) {
        <rt-dropdown-item (click)="action.emit(ActionType.Unarchive)">
          <rt-icon prefix name="unarchive" />
          {{ 'app.offers.unarchive' | translate }}
        </rt-dropdown-item>
      }
      @if (
        offer.status === OfferStatus.Archived ||
        (offer.kind === OfferKind.Job && offer.status === OfferStatus.Draft)
      ) {
        <rt-dropdown-item (click)="action.emit(ActionType.Delete)">
          <rt-icon prefix name="delete" />
          {{ 'app.common.delete' | translate }}
        </rt-dropdown-item>
      }
    }
  </rt-dropdown>
</ng-template>
